import dynamic from 'next/dynamic';
import useAuth from 'src/app/auth/use-auth';
import { useFeatureFlag } from 'components/feature-flag';

const PublishStudio = dynamic(() => import('src/app/studio/publish'), {
  ssr: false,
});

// We have many different post types, e.g. project, campagin, contest, so page `new` will be common page
// and dynamic import component by different query string, e.g. /new?type=contest.

function NewPost() {
  const [enabled] = useFeatureFlag({
    name: 'local_project',
    defaultShow: true,
  });
  useAuth({ required: !enabled });
  return <PublishStudio />;
}

export default NewPost;
